import { FolderHeart, Grid2X2, MapPin, Sparkles } from "lucide-react";

export const allSolarTerms = [
  "小寒", "大寒", "立春", "雨水", "惊蛰", "春分", "清明", "谷雨",
  "立夏", "小满", "芒种", "夏至", "小暑", "大暑", "立秋", "处暑",
  "白露", "秋分", "寒露", "霜降", "立冬", "小雪", "大雪", "冬至",
];

function yearLabel(photos) {
  const year = photos[0] ? new Date(photos[0].capturedAt).getFullYear() : new Date().getFullYear();
  return String(year).replace(/0/g, "〇").replace(/1/g, "一").replace(/2/g, "二").replace(/3/g, "三").replace(/4/g, "四").replace(/5/g, "五").replace(/6/g, "六").replace(/7/g, "七").replace(/8/g, "八").replace(/9/g, "九");
}

function uniqueValues(type, photos) {
  if (type === "time") return [...new Set(photos.map((photo) => String(new Date(photo.capturedAt).getFullYear())))];
  if (type === "location") return [...new Set(photos.map((photo) => photo.location).filter(Boolean))];
  if (type === "style") return [...new Set(photos.flatMap((photo) => photo.styles || []))];
  return allSolarTerms;
}

export function FilterRail({ type, photos, value, onChange }) {
  const effectiveType = type === "all" ? "solarTerm" : type;
  const values = uniqueValues(effectiveType, photos);
  const activeValues = new Set(
    effectiveType === "solarTerm"
      ? photos.map((photo) => photo.solarTerm)
      : uniqueValues(effectiveType, photos),
  );

  return (
    <aside className="filter-rail" aria-label="筛选索引">
      <div className="rail-year">二〇二六年</div>
      <div className="rail-caption">{yearLabel(photos)} · 私人档案</div>
      <div className="rail-list">
        {values.map((item) => (
          <button
            className={`${value === item ? "active" : ""} ${activeValues.has(item) ? "available" : ""}`}
            key={item}
            type="button"
            onClick={() => onChange(value === item ? "" : item, effectiveType)}
          >
            <span className="rail-dot" />
            <span>{item}</span>
          </button>
        ))}
      </div>
      <div className="rail-tools" aria-hidden="true">
        <Grid2X2 size={17} strokeWidth={1.3} />
        <FolderHeart size={17} strokeWidth={1.3} />
        {effectiveType === "location" ? <MapPin size={17} strokeWidth={1.3} /> : <Sparkles size={17} strokeWidth={1.3} />}
      </div>
    </aside>
  );
}
